import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import Typography from '../Typography';
import ScheduleEvent from './ScheduleEvent';
import groupBy from '../lib/groupBy';

function ScheduleDay({ classes, items, styles }) {
  const itemsByTimeframe = groupBy(items, 'time');

  return (
    <div className={classes.root}>
      {Object.keys(itemsByTimeframe).map(time => (
        <div key={time} className={classes.timeframe}>
          <Typography className={classes.time} style={{ ...styles.colors.text, ...styles.detail }}>
            {time}
          </Typography>
          <div className={classes.eventsWrapper}>
            {itemsByTimeframe[time].map((itemData, i) => (
              <ScheduleEvent key={itemData.id || i} data={itemData} styles={styles} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

ScheduleDay.propTypes = {
  classes: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
  styles: PropTypes.object,
};

ScheduleDay.defaultProps = {
  styles: null,
};

const stylesheet = theme => ({
  '@keyframes fade-in': {
    '0%': {
      opacity: 0,
      transform: `translate(0,-10px)`,
    },
    '100%': {
      opacity: 1,
      transform: `translate(0,0)`,
    },
  },
  root: {
    flex: 2,
    animation: 'fade-in 0.75s ease-out',
  },
  timeframe: {
    '&:not(:last-child)': {
      marginBottom: 3 * theme.spacing.unit,
    },
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'flex-start',
    },
  },
  time: {
    minWidth: 60,
    width: '15%',
    fontSize: 20,
    lineHeight: 1.2,
    marginTop: theme.spacing.unit,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 2 * theme.spacing.unit,
    },
  },
  eventsWrapper: {
    width: '100%',
  },
});

export default injectSheet(stylesheet)(ScheduleDay);



// WEBPACK FOOTER //
// ./src/site-render/src/ScheduleSection/ScheduleDay.js